import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkr',
  templateUrl: './checkr.component.html',
  styleUrls: ['./checkr.component.scss']
})
export class CheckrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
